export default function minutesToHoursMinutesString(
        minutes:number, hoursPostfix = "h.",
        minutesPostfix = "m.", separator = '', forceShow = false
    ) {

    const {hours,mins} = gd.utils.minutesToHM(minutes);

    let res = "";

    if (hours) res += hours + hoursPostfix + " ";
    else if (forceShow) res += "0" + hoursPostfix + " ";

    res += separator;

    if (mins) res += mins + minutesPostfix;

    else if (forceShow) res += "0"  + minutesPostfix;

    return res;

}

